// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2FKI_","col":"CardReaderDesc_col__2KpH4","label":"CardReaderDesc_label__KI1Aw"};